import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IEventsState, eventsAdapter, eventsKey } from './events.state';

export const selectEventsState = createFeatureSelector<IEventsState>(eventsKey);

const { selectAll, selectEntities, selectIds, selectTotal } = eventsAdapter.getSelectors(selectEventsState);

export const selectAllEvents = selectAll;
export const selectEventEntities = selectEntities;
export const selectEventIds = selectIds;
export const selectEventsTotal = selectTotal;

export const selectEventsLoading = createSelector(selectEventsState, state => state.loading);
export const selectEventsLoaded = createSelector(selectEventsState, state => state.loaded);
export const selectEventsError = createSelector(selectEventsState, state => state.error);
export const selectPrevEventsRequest = createSelector(selectEventsState, state => state.request);

export const selectEventsById = (eventId: string) =>
  createSelector(selectEventEntities, eventsMap => eventsMap[eventId]);

export const selectEventsHistory = createSelector(selectEventsState, state => state.history);

export const selectEventHistoryById = (eventId: string) =>
  createSelector(selectEventsHistory, history => history[eventId] ?? []);

export const selectEventsHistoryCounts = createSelector(selectEventsState, state => state.historyCounts);

export const selectEventHistoryCountsById = (eventId: string) =>
  createSelector(selectEventsHistoryCounts, counts => counts[eventId]);
